import dayjs from 'dayjs';
import { FinancialTransactionInputData } from '@/features/dashboard/financialTransactions/schemas/financialTransactionSchema.ts';
import { PlannedTransactionDetailDto } from '@/features/dashboard/plannedTransactions/types/PlannedTransactionDetailDto.ts';
import { TransactionAllocationType } from '@/features/dashboard/financialTransactions/types/TransactionAllocation.ts';
import { TransactionDirection } from '@/features/dashboard/financialTransactions/types/TransactionDirection.ts';
import { PaymentMethod } from '@/features/dashboard/tourConfig/types/PaymentMethod.ts';

export const plannedTransactionDetailDtoMapper = {
  /**
   * Rata oznaczana ręcznie jako opłacona staje się wpłatą klienta przypisaną
   * w całości do rezerwacji tej raty. Kierunek i typ przypisania są tu stałe,
   * ale muszą stać w danych jawnie: schemat transakcji ich wymaga, a formularz
   * pokazuje kierunek jako zamkniętą pigułkę.
   */
  fromDtoToForm: (
    dto: PlannedTransactionDetailDto,
    clientId: string,
  ): FinancialTransactionInputData => {
    const today = dayjs().format('DD.MM.YYYY');

    const descriptionPrefix = `Ręcznie oznaczone jako opłacone dnia ${today}.\n\n`;
    const description = dto.description
      ? `${descriptionPrefix}${dto.description}`
      : descriptionPrefix.trim();

    return {
      direction: TransactionDirection.INCOMING,
      clientId,
      amount: dto.amount.amount,
      currency: dto.amount.currency,
      paymentMethod: PaymentMethod.TRANSFER,
      transactionDate: new Date(),
      transactionTime: dayjs().format('HH:mm'),
      description,
      allocations: [
        {
          type: TransactionAllocationType.BOOKING,
          bookingId: dto.bookingId,
          expensePlannedTransactionId: '',
          amount: dto.amount.amount,
        },
      ],
    };
  },
};
